import { type Dispatch, useEffect } from 'react';
import { getLastSearchHotel } from 'shared/search/common/lastSearch';
import actions from '../../../hotel/hotelActions';
import type { hotelDefaultState } from '../../../hotel/hotelDefaultState';

export const useHotelInitialState = (
    dispatch: Dispatch<ReturnType<(typeof actions)[keyof typeof actions]>>,
    prefill?: Partial<typeof hotelDefaultState>,
) => {
    useEffect(() => {
        if (!prefill) {
            dispatch(actions.allFieldsChanged(getLastSearchHotel()));
        }
    }, [dispatch, prefill]);
};
